<template>
    <sa-page-layout ref="SaPostiLetto" :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <ras-configurazione-posti-letto-piani-edit-component :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></ras-configurazione-posti-letto-piani-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RasConfigurazionePostiLettoPianiEditComponent from "../components/RasConfigurazionePostiLettoPianiEditComponent.vue";
export default {
    components: { SaPageLayout, RasConfigurazionePostiLettoPianiEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsapostilettopiani",
            linkback: "/configurazioni/rsaconfigurazionepostilettopiani",
            jsonData: {},
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>

<style></style>
